import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import { useConfigStore } from '@/stores/config'
import { useRequestsStore } from '@/stores/requests'
import { useTranslaterStore } from '@/stores/translater'

export const useTokenStore = defineStore('token', () => {

    const configStore       = useConfigStore()
    const requestsStore     = useRequestsStore()
    const translaterStore   = useTranslaterStore()

    const REQUEST_DELAY     = 5000
    const access            = ref(null)
    const refresh           = ref(null)
    const accessExpired     = ref(null)
    const refreshExpired    = ref(null)
    const refreshPromise    = ref(null)

    const getTranslate = computed(() => translaterStore.getTranslate)

    async function addToken(payload) {

        if(payload) {

            access.value            = payload.tokens.access
            refresh.value           = payload.tokens.refresh
            accessExpired.value     = payload.tokens.accessExpires.at * 1000
            refreshExpired.value    = payload.tokens.refreshExpires.at * 1000

            localStorage.setItem('UTA_TOKEN_ACCESS',    payload.tokens.access)
            localStorage.setItem('UTA_TOKEN_REFRESH',   payload.tokens.refresh)
            localStorage.setItem('UTA_AE',              payload.tokens.accessExpires.at * 1000)
            localStorage.setItem('UTA_RE',              payload.tokens.refreshExpires.at * 1000)
            localStorage.setItem('UTA_UUID',            payload.uuid)

        } else if(

            localStorage.getItem('UTA_TOKEN_ACCESS') && 
            localStorage.getItem('UTA_TOKEN_REFRESH') && 
            localStorage.getItem('UTA_AE') && 
            localStorage.getItem('UTA_RE') &&
            localStorage.getItem('UTA_UUID')

        ) {

            access.value            = localStorage.getItem('UTA_TOKEN_ACCESS')
            refresh.value           = localStorage.getItem('UTA_TOKEN_REFRESH')
            accessExpired.value     = localStorage.getItem('UTA_AE')
            refreshExpired.value    = localStorage.getItem('UTA_RE')

        } else {

            access.value = null
        }

        return access.value
    }

    async function refreshToken() {

        /**
         * 
         * Теоритически, цикл попыток повтора запроса может продолжаться безконечно 
         * с интервалами 5 секунд. Но, возможно, стоило бы добавить ограничение 
         * по кол-ву попыток повтора. Например, 20 или т.п.
         * 
         * Бесконечные циклы - не лучшая практика и нотисы ESLint тому подтверждение. 
         * 
         */
        /* eslint no-constant-condition: 0 */
        while (true) {

            try {

                const request = await requestsStore.fetchRequestWoToken({
                    address: `${configStore.httpServer}/auth/refresh_access_token`, 
                    method: 'POST', 
                    data: { refresh: refresh.value }
                })

                if(!request.error) {

                    access.value        = request.access
                    accessExpired.value = request.accessExpires.at * 1000

                    localStorage.setItem('UTA_TOKEN_ACCESS',    request.access)
                    localStorage.setItem('UTA_AE',              request.accessExpires.at * 1000)

                    return request

                } else {

                    access.value = null
                    requestsStore.logout()
                    
                    return false
                }
            
            } catch (error) {
                console.error(
                    `${getTranslate.value.ERROR}:`,
                    error.message,
                    `${getTranslate.value.TOKEN_REPEAT_REQUEST} ${REQUEST_DELAY / 1000} ${getTranslate.value.UNIT_SECOND_LONG}`
                )
                await new Promise(resolve => setTimeout(resolve, REQUEST_DELAY))
            }
        } 
    }

    return {

        access, 
        refresh, 
        accessExpired, 
        refreshExpired, 
        refreshPromise, 
        addToken, 
        refreshToken
    }
})